/**
 * LeadForge France - Error Boundary
 *
 * Empêche qu'une erreur de rendu locale (ex. un composant tiers qui `throw`)
 * démonte toute l'application et laisse un écran blanc. Affiche un encart de
 * secours + bouton "Réessayer" / "Accueil", et logge l'erreur en console.
 */
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log console uniquement (pas de dépendance externe). Récupérable via la
    // console navigateur et les rapports d'erreurs éventuels.
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="container-custom py-16 text-center" role="alert">
        <h1 className="text-2xl font-bold text-[#0F172A] mb-3">
          Une erreur est survenue sur cette page
        </h1>
        <p className="text-[#64748B] mb-8 max-w-md mx-auto">
          Votre session et votre sélection sont conservées. Vous pouvez réessayer
          ou revenir à l'accueil — rien n'a été perdu.
        </p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={this.handleRetry}
            className="px-4 py-2 rounded-lg bg-[#2563EB] text-white text-sm font-medium hover:bg-[#1d4ed8]"
          >
            Réessayer
          </button>
          <a
            href="/"
            className="px-4 py-2 rounded-lg border border-[#E2E8F0] text-[#0F172A] text-sm font-medium hover:bg-[#F1F5F9]"
          >
            Retour à l'accueil
          </a>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
